export enum PRODUCT_COMPONENTS {
  TITLE,
  TAGS,
  PRICES,
  ADD_TO_CART,
  DESCRIPTION,
  COMBO_LIST,
  TOPPINGS,
  ADDITIONAL_INFO,
  AVAILABILITY,
}

export const COMPONENTS_FOR_DEFAULT = [
  PRODUCT_COMPONENTS.TITLE,
  PRODUCT_COMPONENTS.TAGS,
  PRODUCT_COMPONENTS.PRICES,
  PRODUCT_COMPONENTS.DESCRIPTION,
  PRODUCT_COMPONENTS.COMBO_LIST,
  PRODUCT_COMPONENTS.TOPPINGS,
  PRODUCT_COMPONENTS.ADDITIONAL_INFO,
  PRODUCT_COMPONENTS.AVAILABILITY,
];

export const COMPONENTS_FOR_PRICE_FIXED = [
  PRODUCT_COMPONENTS.TITLE,
  PRODUCT_COMPONENTS.TAGS,
  PRODUCT_COMPONENTS.PRICES,
  PRODUCT_COMPONENTS.TOPPINGS,
  PRODUCT_COMPONENTS.ADDITIONAL_INFO,
  PRODUCT_COMPONENTS.AVAILABILITY,
  PRODUCT_COMPONENTS.ADD_TO_CART,
  PRODUCT_COMPONENTS.DESCRIPTION,
  PRODUCT_COMPONENTS.COMBO_LIST,
];
